import { render, staticRenderFns } from "./InitialIdentityValidationTwoSteps.vue?vue&type=template&id=90e22a8c&"
import script from "./InitialIdentityValidationTwoSteps.vue?vue&type=script&lang=js&"
export * from "./InitialIdentityValidationTwoSteps.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports